import { Device } from 'DeviceUtils';
import { StyleSheet } from 'react-native';
import { TOP_BAR_TOTAL_HEIGHT } from '../../Navigation/Menu/Menu.styles';

import Theme from 'Theme';

const WEB_TOP_MARGIN = 40;
const baseStyles = {
    remainingCount: {
        marginHorizontal: Theme.primaryMargin,
        paddingTop: 10
    },
    sectionList: {},
    sectionListItemContainer: {
        marginLeft: Device.isWeb ? 20 : 10
    },
    sectionHeader: {
        marginTop: Device.isTabletOrWeb ? 25 : 25,
        marginLeft: Device.isWeb ? 20 : 22
    },
    sectionText: {
        marginLeft: 10
    },
    playAssetContainer: {
        marginHorizontal: Theme.primaryMargin,
        marginBottom: 50,
        alignItems: 'center'
    },
    button: {
        minWidth: 250
    },
    outerContainer: { marginTop: TOP_BAR_TOTAL_HEIGHT + WEB_TOP_MARGIN }
};

export default StyleSheet.create(baseStyles);
